// extracted by mini-css-extract-plugin
module.exports = {"hidden":"passReview_hidden__T4KcB","textEmphasis":"passReview_textEmphasis__2XTbm","wrapper":"passReview_wrapper__C4EtU","titleArea":"passReview_titleArea__qUYJb"};